import { RouteType } from "types/RouteType";
// import DecisionTrackerIcon from '@mui/icons-material/FormatListNumbered';

const decisionTrackerRoute: RouteType = {
  name: "Decision Tracker",
  path: "/decision-tracker",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Decision Tracker",
      // component: () => import('./DecisionTracker.Header'), // Assuming a header component exists
      enableRefreshButton: true,
      enableBackButton: true,
    },
    body: {
      component: () => import("./DecisionTracker.Body"), // Assuming a body component exists
    },
  },
  // icon: DecisionTrackerIcon, // Keep the icon as is
  // Keep sideBarShortcut
  // Keep homeShortcut
  group: "Operations",
  hidden: true, // Keep hidden
  requiresAuth: true, // Add requiresAuth, assuming it's required
  requiresPermission: false,
  channels: ["list-tracker"],
  // onEnter: async ({ rootStore }) => {
  //   const {
  //     listTrackerStore: { find },
  //   } = rootStore;
  //   find();
  // },
  // onExit: async ({ rootStore, queryParams }) => {
  //   if (queryParams?.tabName) {
  //     setTimeout(() => {
  //       const {
  //         routerStore: { clearQueryParams, queryParams },
  //       } = rootStore;
  //       if (queryParams && queryParams.tabName && !queryParams.dialogName) {
  //         console.log('onExit clearQueryParams');
  //         return clearQueryParams();
  //       }
  //     }, 300);
  //   }
  // },
  // onParamsChange: async ({ rootStore, queryParams }) => {
  //   const {
  //     listTrackerStore: { find },
  //   } = rootStore;
  //   if (queryParams?.tabName) {
  //     find({ query: { listName: queryParams.tabName } });
  //   }
  // },
};

export default decisionTrackerRoute;
